const RecoveryStatus = {
  PENDING: 'PENDING',
  RECOVERED: 'RECOVERED',
};

module.exports = {
  RecoveryStatus,
};
